import React, { useState } from 'react';
import { noop } from 'lodash';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';

import { ButtonTypes, PrimaryButton } from '@ad-scripts/presentation/components/common/button';
import complianceEventsResource from 'src/actions/compliance/complianceEventsResource';
import ExternalLink from 'src/presentation/components/pages/shared/ExternalLink';
import { SearchInput } from 'src/presentation/components/agent_desktop_components';
import TableHeader from 'src/presentation/components/layouts/table/TableHeader';

const description = (
  <span data-aid="compliance-events-description">
    Review details about customer compliance events performed by compliance admins. Learn more about compliance events
    in our{' '}
    <ExternalLink data-aid="learn-about-compliance-events" to="https://help.gladly.com/docs/compliance-event-log" />.
  </span>
);

const ComplianceEventPageHeader = (): JSX.Element => {
  const dispatch = useDispatch();

  const [searchRef, setSearchRef] = useState<HTMLInputElement>();

  const handleSearch = () => {
    const identifier = searchRef?.value;
    dispatch(complianceEventsResource.effects.fetch({ identifier }));
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  const handleChange = event => {
    // click on  clear text (cross) button inside search input is triggering change event
    if (event.type === 'click') {
      handleSearch();
    }
  };

  return (
    <TableHeader
      actionButtons={noop}
      searchPlaceholder="Search events by customer ID, email, and phone number"
      header="Compliance Event Log"
      description={description}
      onChangeSearchFilter={noop}
      searchInputControl={
        <SearchControlContainer>
          <StyledSearchInput
            onChange={event => handleChange(event)}
            onKeyDown={event => handleKeyDown(event)}
            placeholder="Search events by customer ID, email, and phone number"
            setInputRef={setSearchRef}
          />
          <PrimaryButton onClick={handleSearch} buttonType={ButtonTypes.SECONDARY}>
            Search
          </PrimaryButton>
        </SearchControlContainer>
      }
    />
  );
};

const StyledSearchInput = styled(SearchInput)`
  margin-right: ${p => p.theme.spacing.stackSmall};
  width: 440px;
`;

const SearchControlContainer = styled.div`
  display flex;
`;

export default ComplianceEventPageHeader;
